import api from './axiosConfig';

export interface AttendanceReportFilters {
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
  employeeId?: string;
  status?: string;
}

export interface LeaveUsageReportFilters {
  leavePeriodId?: string;
  departmentId?: string;
  employeeId?: string;
  searchTerm?: string;
}

export interface MobileCheckinReportFilters {
  employeeId?: string;
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
  deviceBased?: string;
}

export interface PunchReportFilters {
  employeeId?: string;
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
}

export interface OvertimeReportFilters {
  employeeId?: string;
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
}

export interface ConsolidatedReportFilters {
  employeeId?: string;
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
}

export interface AlertsReportFilters {
  employeeId?: string;
  fromDate?: string;
  toDate?: string;
  departmentId?: string;
}

export const reportsApi = {
  getAttendance: async (filters: AttendanceReportFilters): Promise<any> => {
    const response = await api.get('/reports/attendance', { params: filters });
    return response.data;
  },

  getLeaveUsage: async (filters: LeaveUsageReportFilters): Promise<any> => {
    const response = await api.get('/reports/leave-usage', { params: filters });
    return response.data;
  },

  getMobileCheckin: async (filters: MobileCheckinReportFilters): Promise<any> => {
    const response = await api.get('/reports/mobile-checkin', { params: filters });
    return response.data;
  },

  getPunchReport: async (filters: PunchReportFilters): Promise<any> => {
    const response = await api.get('/reports/punch', { params: filters });
    return response.data;
  },

  getOvertimeReport: async (filters: OvertimeReportFilters): Promise<any> => {
    const response = await api.get('/reports/overtime', { params: filters });
    return response.data;
  },

  getConsolidatedReport: async (filters: ConsolidatedReportFilters): Promise<any> => {
    const response = await api.get('/reports/consolidated', { params: filters });
    return response.data;
  },

  getAlertsReport: async (filters: AlertsReportFilters): Promise<any> => {
    const response = await api.get('/reports/alerts', { params: filters });
    return response.data;
  },
};
